module.exports = __webpack_public_path__ + "static/compound-arc-57188ad7205642ded1f19c466644f7c8.png";